<template>
  <div id="EditLoggedDirectPaidHours" class="wrap">
    <v-app-bar extended extension-height="10" class="grey lighten-3 desktopHeader--remove hidden-md-and-up"  fixed  elevate-on-scroll  v-if="directPaidHoursInfo">
      <v-layout column align-center class="justify-center">
        <span class="title light-blue--text text--darken-3 text-center">Edit Hours</span>
        <v-layout row align-baseline class=" ">
            <span class="subheading ">{{directPaidHoursInfo.organization_name}}  - </span>

            <v-layout v-if="loggedHour.date !== ''">
              <span class=" subheading ml-1  ">{{loggedHour.date | moment(" MM/DD/YYYY") }}</span>
            </v-layout>

            <v-layout v-if="loggedHour.from_date !== '' && loggedHour.to_date !== '' && loggedHour.from_date !== null && loggedHour.to_date !== null">
              <span class=" subheading ml-1 ">{{loggedHour.from_date | moment(" MM/DD/YYYY") }} - </span>
              <span class=" subheading ml-1  ">{{loggedHour.to_date | moment(" MM/DD/YYYY") }} </span>
            </v-layout>


          </v-layout>
      </v-layout>
    </v-app-bar>

    <div class="maxContainer">
      <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8  px-0" v-if="directPaidHoursInfo">
          <v-container class=" py-0 pb-0 px-0 ">
            <div @click="back" class="headerFake__back">
              <a class="headerFake__backLink">
                <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
                <span class="headerFake__backText">Back</span>
              </a>
            </div>
          </v-container>
          <v-card class=" mb-5 pt-0" flat  >


            <v-card-text class="mt-0 pt-0 px-0">

                <v-layout column align-center class="justify-center mb-3 hidden-sm-and-down">
                  <span class="headline light-blue--text text--darken-3 text-center">Edit Hours</span>
                  <v-layout row align-baseline class=" ">
                      <span class="subheading ">{{directPaidHoursInfo.organization_name}}  - </span>

                      <v-layout v-if="loggedHour.date !== ''">
                        <span class=" subheading ml-1  ">{{loggedHour.date | moment(" MM/DD/YYYY") }}</span>
                      </v-layout>

                      <v-layout v-if="loggedHour.from_date !== '' && loggedHour.to_date !== '' && loggedHour.from_date !== null && loggedHour.to_date !== null">
                        <span class=" subheading ml-1 ">{{loggedHour.from_date | moment(" MM/DD/YYYY") }} - </span>
                        <span class=" subheading ml-1  ">{{loggedHour.to_date | moment(" MM/DD/YYYY") }} </span>
                      </v-layout>


                    </v-layout>
                </v-layout>
              <!-- Edit Single Date -->
              <v-container v-if="loggedHour.date !== '' && loggedHour.date !== null && loggedHour.date !== undefined " grid-list-md pt-0 >
                <!-- Single  Date -->
                <v-flex xs12>
                  <v-menu
                      :close-on-content-click="false"
                      v-model="menu2"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"

                    >
                      <template v-slot:activator="{ on }">
                      <v-text-field

                        :value="computedSingleDateFormattedMomentjs"
                        label="Single Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        clearable
                        outlined

                          v-on="on"
                      ></v-text-field>
                        </template>
                      <v-date-picker  v-model="loggedHour.date" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-flex>

                <!-- Single Hours -->
                <v-text-field
                    v-model="loggedHour.hours"
                    label="Hours"
                    prepend-inner-icon="mdi-clock-outline"
                    outlined
                  >
                </v-text-field>

                <!-- Save Button -->
                <v-layout row class="mt-2 mb-3 mx-1">
                  <v-btn color="green"  block dark large @click.native="editPaDirectPaidHours()">Save</v-btn>
                </v-layout>
              </v-container>

              <!-- Edit Date Range and Hours -->
              <v-container  v-else grid-list-md pt-0 >

                  <!-- From Date -->
                  <v-flex xs12>
                    <v-menu
                        :close-on-content-click="false"
                        v-model="menu3"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computedFromDateFormattedMomentjs"
                          label="Start Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          clearable
                          outlined
                          v-on="on"
                        ></v-text-field>
                          </template>
                        <v-date-picker  v-model="loggedHour.from_date" no-title @input="menu3 = false"></v-date-picker>
                      </v-menu>
                  </v-flex>
                  <!-- To Date -->
                  <v-flex xs12>
                    <v-menu
                        :close-on-content-click="false"
                        v-model="menu4"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computedToDateFormattedMomentjs"
                          label="End Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          clearable
                          outlined
                          v-on="on"
                        ></v-text-field>
                          </template>
                        <v-date-picker  v-model="loggedHour.to_date" no-title @input="menu4 = false"></v-date-picker>
                      </v-menu>
                  </v-flex>


                <!-- Date Range Shadowing Hours -->
                <v-text-field
                    v-model="loggedHour.date_range_hours"
                    label="Hours"
                    prepend-inner-icon="mdi-clock-outline"
                    outlined
                  >
                </v-text-field>

                <!-- Save Button -->
                <v-layout row class="mt-2 mb-3 mx-1">
                  <v-btn color="green"  block dark large @click.native="editPaDirectPaidHours()">Save</v-btn>
                </v-layout>
              </v-container>
            </v-card-text>

          </v-card>
    </div>
    </div>

    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>

  </div>

</template>

<script>
  import moment from 'moment'
  export default {
     data() {
      return {
        modal: false,
        alert: false,
        menu2: false,
        menu3: false,
        menu4: false,
        EditPaDirectPaidHoursDialog: false,

      }
    },
    methods: {

       back() {
        this.$router.go(-1)
      },
      showEditPaDirectPaidHoursDialog(user) {
        if(user !== null && user !== undefined ){
          this.EditPaDirectPaidHoursDialog = true
        }
        else {
          this.alert = true
        }
      },
      editPaDirectPaidHours () {
         if(this.loggedHour.date_range_hours !== '' && this.loggedHour.date_range_hours !== null && this.loggedHour.date_range_hours !== undefined) {
            this.loggedHour.hours = this.loggedHour.date_range_hours
          }
        const loggedDirectPaidHours = {
         date: this.loggedHour.date,
         hours : this.loggedHour.hours,
         date_range_hours: this.loggedHour.date_range_hours,
         from_date: this.loggedHour.from_date,
         to_date: this.loggedHour.to_date,
         loggedHourId : this.loggedHour.id,
         directPaidHoursId: this.directPaidHoursInfo.id
        }

        this.EditPaDirectPaidHoursDialog = false

        this.$store.dispatch('setEditLoggedDirectPaidHours', loggedDirectPaidHours)
        this.$router.go(-1)

      }
    },
    computed : {
      directPaidHoursInfoId () {
        return this.$route.params.directPaidHoursInfoId
      },

      loggedHourId () {
        return this.$route.params.loggedHourId
      },
      user () {
        return this.$store.getters.user
      },
      directPaidHoursInfo () {
        return this.$store.getters.directPaidHoursInfo(this.directPaidHoursInfoId)
      },
      loggedHour() {
        if (!this.directPaidHoursInfo) return 0
        return this.directPaidHoursInfo.logged_hours.find((loggedHour) => {
            return loggedHour.id === this.loggedHourId
          })
        },
      computedSingleDateFormattedMomentjs () {
        return this.loggedHour.date ? moment(this.loggedHour.date).format('MM/DD/YYYY') : ''
      },
      computedFromDateFormattedMomentjs () {
        return this.loggedHour.from_date ? moment(this.loggedHour.from_date).format('MM/DD/YYYY') : ''
      },
      computedToDateFormattedMomentjs () {
        return this.loggedHour.to_date ? moment(this.loggedHour.to_date).format('MM/DD/YYYY') : ''
      }

    },


  }
</script>

<style scoped>
 #headerToolbar {
    position: sticky;
    box-shadow: 0 10px 30px -10px #11111130;
  }

  .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }
@media (min-width: 960px) {
  .desktopHeader {
    width: calc(100% - 256px);
    margin-left: 256px;
  }
}

.headerFake__back {
  padding-bottom: 40px;
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/DirectPaidHours/EditLoggedHours/EditLoggedDirectPaidHours.vue